export var SharedRole = /*#__PURE__*/ function(SharedRole) {
    SharedRole["Main"] = "Main";
    SharedRole["Alternate"] = "Alternate";
    SharedRole["Supplementary"] = "Supplementary";
    SharedRole["Emergency"] = "Emergency";
    SharedRole["Karaoke"] = "Karaoke";
    SharedRole["Unknown"] = "Unknown";
    return SharedRole;
}({});
// When the role provided by the underlying player track API is defined but not known on one of the roles enumerators
export var VideoExclusiveRole = /*#__PURE__*/ function(VideoExclusiveRole) {
    VideoExclusiveRole["Caption"] = "Caption";
    VideoExclusiveRole["Subtitle"] = "Subtitle";
    VideoExclusiveRole["Sign"] = "Sign";
    VideoExclusiveRole["Easyreader"] = "Easyreader";
    return VideoExclusiveRole;
}({});
export var TextExclusiveRole = /*#__PURE__*/ function(TextExclusiveRole) {
    TextExclusiveRole["Caption"] = "Caption";
    TextExclusiveRole["Subtitle"] = "Subtitle";
    TextExclusiveRole["Commentary"] = "Commentary";
    TextExclusiveRole["Dub"] = "Dub";
    TextExclusiveRole["Description"] = "Description";
    TextExclusiveRole["Metadata"] = "Metadata";
    TextExclusiveRole["ForcedSubtitle"] = "ForcedSubtitle";
    TextExclusiveRole["Easyreader"] = "Easyreader";
    return TextExclusiveRole;
}({});
export var AudioExclusiveRole = /*#__PURE__*/ function(AudioExclusiveRole) {
    AudioExclusiveRole["Commentary"] = "Commentary";
    AudioExclusiveRole["Dub"] = "Dub";
    AudioExclusiveRole["Description"] = "Description";
    AudioExclusiveRole["EnhancedAudioIntelligibility"] = "EnhancedAudioIntelligibility";
    AudioExclusiveRole["MainDesc"] = "MainDesc";
    AudioExclusiveRole["Alternative"] = "Alternative";
    AudioExclusiveRole["Translation"] = "Translation";
    return AudioExclusiveRole;
}({});
export var ApplicationExclusiveRole = /*#__PURE__*/ function(ApplicationExclusiveRole) {
    ApplicationExclusiveRole["Metadata"] = "Metadata";
    return ApplicationExclusiveRole;
}({});

//# sourceMappingURL=role.enum.js.map